/**
 * Pages
 */

export {ServiceCampaignsOverview} from './pages/ServiceCampaigns/ServiceCampaignsOverview';
export {ServiceCampaignDetail} from './pages/ServiceCampaignDetail/ServiceCampaignDetail';
